export default __webpack_public_path__ + "static/BannerJsonImageAndTextWithAction_ImageRightLight-b9a85ac48156edcde6d315f3d33288fe.jpg";